<template>
  <div class="datepicker-body">
    <table class="date-table">
      <tr>
        <th
          v-for="dayName in days"
          :key="dayName"
        >
          <label
            class="day-label"
            v-text="getDayTranslation(dayName)"
          >
          </label>
        </th>
      </tr>

      <tr
        v-for="week in monthRoster"
        :key="week.id"
      >
        <td
          v-for="weekDay in week.value"
          :key="weekDay.id"
        >
          <datepicker-button
            class="day-button"
            :text="'' + weekDay.date"
            :forced-active="weekDay.isSelected"
            :is-current-date="weekDay.isCurrentDay"
            :current-month="weekDay.isInCalenderMonth"
            :disabled="weekDay.disabled"
            @clicked="updateDay(weekDay)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import MomentJS from 'moment'

  import Locales from '../../../localization/Locales'

  import DatepickerButton from '../buttontemplates/DatepickerButton'

  export default {
    name: 'DatepickerBody',
    components: {
      'datepicker-button': DatepickerButton
    },

    i18n: {
      messages: Locales
    },

    data () {
      return {
        days: [
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat',
          'Sun'
        ]
      }
    },
    props: {
      // year/month currently displaying
      calender: {
        default: function () {
          return {}
        },
        type: Object
      },
      // currently selected date
      value: {
        default: function () {
          return {}
        },
        type: Object
      },
      // disables value display
      isNull: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      calenderMoment () {
        let self = this
        return MomentJS(self.calender)
      },
      selectedMoment () {
        let self = this
        return MomentJS(self.value)
      },
      currentMoment () {
        return MomentJS(new Date())
      },
      bufferDays () {
        let self = this
        return MomentJS(new Date(
        self.calender.years,
        self.calender.months,
        0)).weekday()
      },
      firstDayInCalenderMonth () {
        let self = this
        let newMoment = new MomentJS()
        newMoment = newMoment.set({
          'year': self.calender.years,
          'month': self.calender.months
        })
        newMoment = newMoment.startOf('month')
        return newMoment
      },
      monthRoster () {
        let self = this
        let resultData = {}
        let dayTracker = 0

        for (let weekCount = 0; weekCount < 6; weekCount++) {
          let weekHolder = {}
          for (let dayCount = 0; dayCount < 7; dayCount++) {
            let dateHolder = MomentJS(self.firstDayInCalenderMonth).subtract(self.bufferDays, 'days')

            dateHolder = dateHolder.add(dayTracker, 'days')

            weekHolder[dayCount] = {
              id: (weekCount + '-' + dayCount),
              year: dateHolder.year(),
              month: dateHolder.month(),
              date: dateHolder.date(),
              isCurrentDay: dateHolder.isSame(self.currentMoment, 'day'),
              isInCalenderMonth: dateHolder.isSame(self.calenderMoment, 'month'),
              isSelected: self.isNull ? false : dateHolder.isSame(self.selectedMoment, 'day'),
              disabled: !dateHolder.isSame(self.calenderMoment, 'month')
            }
            dayTracker++
          }
          resultData[weekCount] = { id: weekCount, value: weekHolder }
        }

        return resultData
      }
    },
    methods: {
      updateDay (newDay) {
        let self = this
        self.$emit('updateDay', newDay.date)
      },
      getDayTranslation (dayCode) {
        let self = this
        switch (dayCode) {
          default:
          case 'Mon':
            return self.$t('days.short.monday')
          case 'Tue':
            return self.$t('days.short.tuesday')
          case 'Wed':
            return self.$t('days.short.wednesday')
          case 'Thu':
            return self.$t('days.short.thursday')
          case 'Fri':
            return self.$t('days.short.friday')
          case 'Sat':
            return self.$t('days.short.saturday')
          case 'Sun':
            return self.$t('days.short.sunday')
        }
      }
    },
    watch: {
      calender: {
        handler: function () {
        },
        immediate: true,
        deep: true
      },
      value: {
        handler: function () {
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  .datepicker-body {
    display: block;
    padding: 20px 25px 0 25px;

    .date-table {
      width: 100%;
      max-width: 100%;

      .th,
      .td {
        margin: 0 2.5px 0 2.5px;
        padding: 0;
        text-align: center;
        align-content: center;

        cursor: default;
      }

      .day-button,
      .day-label {
        height: 25px;
        width: 25px;
      }
      .day-button {
        display: block;
        margin: auto;
      }
      .day-label {
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 13px;
        color: $primaryBorderColor;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/datepicker/DatepickerBody.vue